export default {
    path: '/paycleaning',
    meta: {
        title: '保洁服务支付',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/paycleaning`),
}


// WEBPACK FOOTER //
// ./src/views/Pay_cleaning/router.js